import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";
import { toast } from "sonner";

const todayIso = () => new Date().toISOString().slice(0, 10);

export const OilChangeDialog = ({ open, onOpenChange, car, onSaved }) => {
  const { t } = useLang();
  const [km, setKm] = useState("");
  const [date, setDate] = useState(todayIso());
  const [notes, setNotes] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setKm(car?.current_km ?? "");
      setDate(todayIso());
      setNotes("");
    }
  }, [open, car]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/oil-changes", {
        car_id: car.car_id,
        changed_at_km: Number(km),
        changed_date: new Date(date + "T12:00:00").toISOString(),
        notes: notes || null,
      });
      toast.success(t("createdOil"));
      onSaved?.();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#121212] border border-white/10 text-white max-w-md">
        <DialogHeader>
          <DialogTitle>{t("recordOilChange")}</DialogTitle>
          <DialogDescription className="text-zinc-500 text-xs uppercase tracking-[0.2em]">
            {t("oilChangeAtKm")}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-[0.2em] text-zinc-400">{t("oilChangeAtKm")} *</Label>
            <Input data-testid="oil-form-km" type="number" value={km} onChange={(e) => setKm(e.target.value)} required className="bg-[#0A0A0A] border-white/10 text-lg font-semibold" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-[0.2em] text-zinc-400">{t("lastOilDate")} *</Label>
            <Input data-testid="oil-form-date" type="date" value={date} onChange={(e) => setDate(e.target.value)} required dir="ltr" className="bg-[#0A0A0A] border-white/10" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs uppercase tracking-[0.2em] text-zinc-400">{t("notes")}</Label>
            <Textarea data-testid="oil-form-notes" value={notes} onChange={(e) => setNotes(e.target.value)} className="bg-[#0A0A0A] border-white/10" />
          </div>
          <DialogFooter className="gap-2">
            <button type="button" onClick={() => onOpenChange(false)} data-testid="oil-form-cancel" className="border border-white/10 bg-transparent hover:bg-[#1C1C1C] px-4 py-2 text-sm">{t("cancel")}</button>
            <button type="submit" disabled={saving} data-testid="oil-form-save" className="bg-white text-black px-4 py-2 text-sm font-semibold hover:bg-zinc-100 disabled:opacity-60">{t("save")}</button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
